/** @module SiteAdmin/HomePage/Pane */
define([
	"dojo/_base/declare",
	"dijit/_WidgetsInTemplateMixin",
	"dijit/TitlePane",
	"csi/html",
	"dojo/text!./Pane.html",
	"dijit/form/TextBox"
], function(declare, _WidgetsInTemplateMixin, TitlePane, html, template) {

	return declare([TitlePane, _WidgetsInTemplateMixin], {
		templateString: template,

		/** @property {DOMNode} copyNode - copy action node */
		copyNode: null,

		/** @property {DOMNode} dragNode - drag handle for pane */
		dragNode: null,

		/** @property {DOMNode} expandNode - expand action node */
		expandNode: null,

		/** @property {DOMNode} refreshNode - refresh action node */
		refreshNode: null,

		/** @property {DOMNode} deleteNode - delete action node */
		deleteNode: null,

		/** @property {DOMNode} titleTextBox - text box used to edit title when in configure mode */
		titleTextBox: null,

		/** @property {boolean} canCopy - indicates if copy icon should be enabled */
		canCopy: true,

		/** @property {boolean} canRefresh - indicates if expand icon should be enabled */
		canRefresh: true,

		/** @property {boolean} canDelete - indicates if delete icon should be enabled */
		canDelete: true,

		/** @property {string} homePageId - unique id for home page pane used for home page layout persistence and custom view context */
		homePageId: "",

		/**
		 * Extension point for when pane's title is changed.
		 * @param {string} value
		 */
		onActionChangeTitle: function(value) { },

		/**
		 * Extension point for when pane is copied.
		 */
		onActionCopy: function() { },

		/**
		 * Extension point for when pane is deleted.
		 */
		onActionDelete: function() { },

		/**
		 * Extension point for when pane is expanded.
		 */
		onActionExpand: function() { },

		/**
		 * Extension point for when pane is refreshed.
		 */
		onActionRefresh: function() { },

		/**
		 * Disable actions that do not apply to this pane.
		 */
		postCreate() {
			this.inherited(arguments);

			const {
				canCopy,
				canDelete,
				copyNode,
				deleteNode,
				title,
				titleTextBox
			} = this;

			copyNode.classList.toggle('dijitDisabled', !canCopy);

			if (!canDelete) {
				html.orphan(deleteNode);
				this.deleteNode = null;
			}

			// keep text box in sync with title
			titleTextBox.set('value', title);
			this.watch('title', (name, oldValue, newValue) => {
				titleTextBox.set('value', newValue);
			});
		},

		/**
		 * Only startup view if titlepane is open.
		 */
		startup: function() {
			var view = this.getView();
			var bReset;

			if (!this.open && view && !view.isStarted()) {
				view._started = true;
				bReset = true;
			}

			this.inherited(arguments);

			if (bReset) {
				view._started = false;
			}
		},

		/**
		 * Return title pane's child view.
		 * @return {ViewWidget}
		 */
		getView: function() {
			return this.getChildren()[0];
		},

		/**
		 * Internal function for when copy action is clicked.
		 * @param {string} value - new title
		 */
		_onPaneChangeTitle: function(value) {
			if (value != this.title) {
				this.set('title', value);
				this.onActionChangeTitle(value);
			}
		},

		/**
		 * Prevent event from propagating up and toggling title pane.
		 */
		_onPaneClickTitle: function(event) {
			event.stopPropagation();
		},

		/**
		 * Internal function for when copy action is clicked.
		 */
		_onPaneCopy: function() {
			if (this.canCopy) {
				this.onActionCopy();
			}
		},

		/**
		 * Internal function for when delete action is clicked.
		 */
		_onPaneDelete: function() {
			this.onActionDelete();
		},

		/**
		 * Internal function for when expand action is clicked.
		 */
		_onPaneExpand: function() {
			this.onActionExpand();
		},

		/**
		 * Internal function for when refresh action is clicked.
		 */
		_onPaneRefresh: function() {
			if (this.canRefresh) {
				this.onActionRefresh();
			}
		},

		/**
		 * Refresh button should only be enabled when open
		 * @param {boolean} value 
		 */
		_setOpenAttr(value) {
			this.refreshNode.classList.toggle('dijitDisabled', !this.canRefresh || !value);
			this.inherited(arguments);
		},

		/**
		 * Override default _setTitleAttr from dijit/TitlePane to use text rather than innerHTML, and also to keep text box in sync.
		 */
		_setTitleAttr: {node: 'titleNode', type: 'innerText'}
	});
});
